module.exports = __webpack_public_path__ + "img/40_38_072_650.95ca58c1.jpg";